import { useIntervalFn } from '@vueuse/core';
import { onBeforeUnmount, ref, toValue, type MaybeRefOrGetter } from 'vue';

// Управляет автопрокруткой hero-карусели: текущий индекс, ключ прогресс-бара,
// ручная навигация и таймер автосмены. `reset` сбрасывает состояние
// (например, при обновлении списка слайдов).
export const useHeroCarousel = (displayedImages: MaybeRefOrGetter<string[]>, interval: number) => {
  const currentImageIndex = ref(0);
  const progressKey = ref(0);

  const count = () => toValue(displayedImages).length;

  const goNext = () => {
    if (count() > 1) {
      currentImageIndex.value = (currentImageIndex.value + 1) % count();
      pause();
      resume();
      progressKey.value++;
    }
  };

  const goPrev = () => {
    if (count() > 1) {
      currentImageIndex.value = (currentImageIndex.value - 1 + count()) % count();
      pause();
      resume();
      progressKey.value++;
    }
  };

  const { pause, resume } = useIntervalFn(() => {
    if (count() > 0) {
      const nextIndex = (currentImageIndex.value + 1) % count();

      if (count() > nextIndex) {
        currentImageIndex.value = nextIndex;
        progressKey.value++;
      }
    }
  }, interval);

  const reset = () => {
    currentImageIndex.value = 0;
    progressKey.value++;
    pause();
    resume();
  };

  onBeforeUnmount(pause);

  return { currentImageIndex, progressKey, goNext, goPrev, pause, resume, reset };
};
